import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router'
import { catchError, map, of } from 'rxjs'
import { UserService } from 'src/app/public/user/service/user.service'
import { AuthLoginService } from './auth-login.service'
import { DOCUMENT } from '@angular/common'

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private readonly userService = inject(UserService)
  private readonly authLoginService = inject(AuthLoginService)
  private readonly document: Document = inject(DOCUMENT)

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    this.authLoginService.lastUrl = `${this.document.location.origin}${state.url}`
    return this.userService.getUser().pipe(
      map(() => true),
      catchError(() => of(false)),
    )
  }
}
